/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ShopForMeItem,
} from '../models/index';
import {
    ShopForMeItemFromJSON,
    ShopForMeItemToJSON,
} from '../models/index';

export interface ShopForMeItemCreateRequest {
    data?: ShopForMeItem;
}

export interface ShopForMeItemDeleteByIdRequest {
    id: string;
}

export interface ShopForMeItemFindRequest {
    filter?: string;
}

export interface ShopForMeItemFindByIdRequest {
    id: string;
    filter?: string;
}

export interface ShopForMeItemPrototypePatchAttributesRequest {
    id: string;
    data?: ShopForMeItem;
}

/**
 * 
 */
export class ShopForMeItemApi extends runtime.BaseAPI {

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async shopForMeItemCreateRaw(requestParameters: ShopForMeItemCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopForMeItem>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ShopForMeItems`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShopForMeItemToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopForMeItemFromJSON(jsonValue));
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async shopForMeItemCreate(requestParameters: ShopForMeItemCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopForMeItem> {
        const response = await this.shopForMeItemCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async shopForMeItemDeleteByIdRaw(requestParameters: ShopForMeItemDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling shopForMeItemDeleteById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShopForMeItems/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async shopForMeItemDeleteById(requestParameters: ShopForMeItemDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.shopForMeItemDeleteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async shopForMeItemFindRaw(requestParameters: ShopForMeItemFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ShopForMeItem>>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShopForMeItems`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ShopForMeItemFromJSON));
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async shopForMeItemFind(requestParameters: ShopForMeItemFindRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ShopForMeItem>> {
        const response = await this.shopForMeItemFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async shopForMeItemFindByIdRaw(requestParameters: ShopForMeItemFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopForMeItem>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling shopForMeItemFindById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShopForMeItems/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopForMeItemFromJSON(jsonValue));
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async shopForMeItemFindById(requestParameters: ShopForMeItemFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopForMeItem> {
        const response = await this.shopForMeItemFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async shopForMeItemPrototypePatchAttributesRaw(requestParameters: ShopForMeItemPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopForMeItem>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling shopForMeItemPrototypePatchAttributes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ShopForMeItems/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ShopForMeItemToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopForMeItemFromJSON(jsonValue));
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async shopForMeItemPrototypePatchAttributes(requestParameters: ShopForMeItemPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopForMeItem> {
        const response = await this.shopForMeItemPrototypePatchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
